import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { ACTION_COMPONENTS } from '../constants/ActionComponents';
import ReportActionsDropdownButton from './ReportActionsDropdownButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportActionDropdown({
  reportActions,
  additionalReportActions,
  appUsageTracker,
  report,
  isReportActionsDisabled,
  toggleDropdownOpen,
  actionsDropdownProps
}) {
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({
    Button: ReportActionsDropdownButton,
    placement: "bottom left",
    disabled: isReportActionsDisabled,
    onOpenChange: toggleDropdownOpen
  }, actionsDropdownProps, {
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: [...reportActions.filter(action => ACTION_COMPONENTS[action]).map(action => {
        const ActionComponent = ACTION_COMPONENTS[action];
        return /*#__PURE__*/_jsx(ActionComponent, {
          appUsageTracker: appUsageTracker,
          report: report
        }, action);
      }), ...additionalReportActions]
    })
  }));
}